import uopService from "../../services/uopService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new uopService();

export const getUopList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_UOP,
      payload: { ...initialState, loading: true },
    });
    service
      .getUopList(data)
      .then((res) => {
        dispatch({
          type: types.GET_UOP,
          payload: { data: res.data.data, loading: false, status: 200 },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_UOP,
          payload: {
            ...initialState,
            message: error?.response?.data?.error,
            loading: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const getUopMeta = () => {
  return (dispatch) => {
    dispatch({
      type: types.META_LIST,
      payload: { ...initialState, loading: true },
    });
    service
      .getMetaList()
      .then((res) => {
        dispatch({
          type: types.META_LIST,
          payload: { data: res.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.META_LIST,
          payload: {
            ...initialState,
            message: error.message || "Error fetching limit dropdown",
            loading: false,
          },
        });
      });
  };
};

export const AddUop = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.ADD_UOP,
      payload: { ...initialState, loading: true },
    });
    return service
      .addUop(data, obj)
      .then((res) => {
        dispatch({
          type: types.ADD_UOP,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.ADD_UOP,
          payload: {
            ...initialState,
            message: error?.response?.data?.error,
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const DeleteUop = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.DELETE_UOP,
      payload: { ...initialState, loader: true },
    });
    return service
      .deleteUop(data)
      .then((res) => {
        dispatch({
          type: types.DELETE_UOP,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })

      .catch((error) => {
        dispatch({
          type: types.DELETE_UOP,
          payload: {
            ...initialState,
            message: error?.response?.data?.error,
            loading: false,
            status: error.response?.status || 500,
          },
        });
         throw error
      });
  };
};

export const clearResponse = () => (dispatch) => {
  dispatch({
    type: types.GET_UOP,
    payload: initialState,
  });
};

export const UpdateUop = ( payload) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_UOP,
      payload: { ...initialState, loading: true },
    });
   return service
      .updateUop( payload)
      .then((res) => {
        dispatch({
          type: types.UPDATE_UOP,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res
      })
      .catch((error) => {
        dispatch({
          type: types.UPDATE_UOP,
          payload: {
            ...initialState,
            message: error?.response?.data?.error,
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error;
      });
  };
};

export const ApproveUop = ( payload) => {
  return (dispatch) => {
    dispatch({
      type: types.APPROVE_UOP,
      payload: { ...initialState, loading: true },
    });
   return service
      .approveUop( payload)
      .then((res) => {
        dispatch({
          type: types.APPROVE_UOP,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res
      })
      .catch((error) => {
        dispatch({
          type: types.APPROVE_UOP,
          payload: {
            ...initialState,
            message: error.response.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error;
      });
  };
};
